import { clone, Container, delayedCall, dispatcher, IGraphics, ingenuity, IObject, ITween, killDelayedCall, Meter, MeterBitmap, SpineBase } from "@quest/base-core";
import { MoneyHuntingView } from "./MoneyHuntingView";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { GameParserModel } from "../Platform/GameParserModel";
import { MeterBehavior, SlotConstantsBehavior, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-panther";
import { Emitter, Linear } from "@quest/pixi-bridge";
import { SlotConstants, SlotEventConstants } from "@quest/slot-core";
import { gameConstants } from "../Constants/gameConstants";
import { SoundConstantGame } from "../Constants/SoundConstantGame";
import { EventConstants } from "@quest/platform-murka-phase_2";

export class MoneyHuntingController {
    protected view: MoneyHuntingView;
    private stickyFetaureContainer: Container;
    private rewardSymbolContainer: Container;
    private rewardSymbolContainerFG: Container;
    private stickyFetaureContainerFG: Container;
    protected winCollectionIndex: number = 0;
    private isMultiplierOnReel: boolean = false;
    private multiplerData: any = [];
    private moneyHuntingCounter: number = 0;
    private monayHuntingData: any = [];
    private collectSymbolData: any = [];
    private stickySymbolContainer: Container;
    private stickySymbolContainerFG: Container;
    private collectPrize: number = 0;
    private introPopupBG: IGraphics;
    private introPopupFG: IGraphics;
    private isTrailAvailable = false
    private smokeEffectAngle: any = { "8": -148, "7": -90, "6": -45, "1": 180, "-1": 0, "-6": 148, "-7": 90, "-8": 45 }
    private moneyHuntingArray = ['addSpotlight', 'addRewardSymbol', 'appliMultiplier', 'applyCollect', 'winCollection', 'hideFeature']
    constructor(view: MoneyHuntingView) {
        this.view = view;
        this.subscribeEvents();
        this.initializedElement();

    }

    private initializedElement(): void {
        this.stickySymbolContainer = this.view.getContainerByID('stickySymbolContainer');
        this.rewardSymbolContainer = this.view.getContainerByID('rewardSymbolContainer');
        this.rewardSymbolContainerFG = this.view.getContainerByID('rewardSymbolContainerFG');
        this.stickySymbolContainerFG = this.view.getContainerByID('stickySymbolContainerFG')
        this.stickyFetaureContainer = this.view.getContainerByID("stickyFetaureContainer");
        this.stickyFetaureContainerFG = this.view.getContainerByID("stickyFetaureContainerFG");
        this.introPopupBG = this.view.getShapeById("introPopupBG");
        this.introPopupFG = this.view.getShapeById("introPopupFG");
    }

    private subscribeEvents(): void {
        // this.unubscribeEvents();
        if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) {
            dispatcher.on(eventDispatchers.START_MONEY_HUNTING_FEATURE_FG, this.startMoneyHuntingFeature, this);
            dispatcher.on(eventDispatchers.START_WIN_COLLECTION_FG, this.startCollectionTrail, this)

        } else {
            dispatcher.on(eventDispatchers.START_MONEY_HUNTING_FEATURE, this.startMoneyHuntingFeature, this);
            dispatcher.on(eventDispatchers.START_WIN_COLLECTION, this.startCollectionTrail, this);
        }
        if (dispatcher.hasEvent(eventDispatchers.HIDE_MONEY_FEATURE)) {
            dispatcher.on(eventDispatchers.HIDE_MONEY_FEATURE, this.onHideMoneyHunting, this)
        }
    }

    private showNextMoneyHuntingPresentation(): void {
        const currentWinEventToShow = this.moneyHuntingArray[this.moneyHuntingCounter];
        this.updateMoneyHuntingCounter();
        switch (currentWinEventToShow) {
            case "addSpotlight":
                this.addSpotlight();
                break;
            case "addRewardSymbol":
                this.addRewardSymbols();
                break;
            case "appliMultiplier":
                this.onApplyMultiplier();
                break;
            case "applyCollect":
                this.onApplyCollect();
                break;
            case "winCollection":
                this.onWinCollectionStart();
                break;
            case "hideFeature":
                this.onHideMoneyHunting();
                break;
        }
    }

    /**
    * Method to updates presentation sequence counter
    */
    private updateMoneyHuntingCounter(): void {
        this.moneyHuntingCounter += 1;
    }

    private onHideMoneyHunting(): void {
        let delayTimer = this.isTrailAvailable ? SlotConstantsBehavior.DURATION_1200 : 0;
        ingenuity.configData.moneyHuntingSkipPressed = false;
        dispatcher.fireEvent(eventDispatchers.HIDE_OVERLAY);
        delayedCall('hideFeature', delayTimer, () => {
            killDelayedCall('hideFeature');
            this.isTrailAvailable = false;
            this.stickySymbolContainer.visible = false;
            this.stickyFetaureContainer.visible = false;
            this.stickyFetaureContainer.alpha = 0;
            this.stickySymbolContainerFG.visible = false;
            this.stickyFetaureContainerFG.visible = false;
            this.stickyFetaureContainerFG.alpha = 0;
            this.winCollectionIndex = 0;
            dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
            this.resetMoneyHuntingData();
        })
    }

    private resetMoneyHuntingData(): void {

        this.multiplerData = [];
        this.moneyHuntingCounter = 0;
        this.rewardSymbolContainer.removeChildren();
        this.rewardSymbolContainerFG.removeChildren();
        this.removeSpotlightFromScreen();
        (ingenuity.parserModel as GameParserModel).setMoneyRewardSpinsCounter(0);
        (ingenuity.parserModel as GameParserModel).setMoneyHuntingFetureStatus(false);
        (ingenuity.parserModel as GameParserModel).setMoneyHuntingRewardsDetails([]);
        // (ingenuity.parserModel as GameParserModel).setMoneyHuntingTotalWin(0);
        (ingenuity.parserModel as GameParserModel).setSpotlightPosition(null);
        (ingenuity.parserModel as GameParserModel).settotalMoneyHuntingSpin(0);
    }

    private removeSpotlightFromScreen(): void {
        let spotlightPos = (ingenuity.parserModel as GameParserModel).getSpotlightPosition();
        if (!spotlightPos) return;
        let child = this.stickyFetaureContainer.getChildByName(`spotlight_${spotlightPos[0]}_${spotlightPos[1]}`);
        let childFG = this.stickyFetaureContainerFG.getChildByName(`spotlight_${spotlightPos[0]}_${spotlightPos[1]}`)
        if (child) {
            this.stickyFetaureContainer.removeChild(child);
        }
        if (childFG) {
            this.stickyFetaureContainerFG.removeChild(childFG);
        }
        if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) {
            dispatcher.fireEvent(eventDispatchers.HIDE_STICKY_FRAMES_CONTAINER_FG);
        }
    }

    /**
    * add sticky wild to container
    */
    private startMoneyHuntingFeature(): void {
        dispatcher.fireEvent(eventDispatchers.INITIALIZE_WIN_COLLECTION);
        if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
            this.stickySymbolContainer.visible = true;
            this.stickyFetaureContainer.visible = true;
            this.stickyFetaureContainer.alpha = 1;
        } else {
            this.stickySymbolContainerFG.visible = true;
            this.stickyFetaureContainerFG.visible = true;
            this.stickyFetaureContainerFG.alpha = 1;
        }
        this.showNextMoneyHuntingPresentation();
    }

    private addSpotlight(): void {
        let spotlightPos = (ingenuity.parserModel as GameParserModel).getSpotlightPosition();
        let spotlight = clone(ingenuity.assetsData.getJSONById("main_data").moneyHunting['searchlight_symbol']);
        spotlight.type = "spine";
        let child = this.view.createSpineClone(spotlight);
        child.visible = true;
        child.name = `spotlight_${spotlightPos[0]}_${spotlightPos[1]}`;
        child.json.id = `spotlight_${spotlightPos[0]}_${spotlightPos[1]}`;
        child.x = spotlight.x + (this.view.json.symWidth * spotlightPos[0]);
        child.y = spotlight.y + (this.view.json.symHeight * spotlightPos[1]);
        if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
            this.stickyFetaureContainer.addChild(child);
        } else {
            child.y = (spotlight.y + (this.view.json.symHeight * spotlightPos[1]) - 1);
            child.x = child.x + 2;
            this.stickyFetaureContainerFG.addChild(child)
        }
        child.playAnim('static');
        child.onComplete.addOnce(() => {
            child.playAnim('searchlight_win');
            this.playSound(SoundConstantGame.LANTERN_ICON_WIN, SlotConstantsBehavior.SOUND_LIST_PRELOAD, false)
            dispatcher.fireEvent(eventDispatchers.GLOW_ALL_FRAMES)
            child.onComplete.addOnce(() => {
                dispatcher.fireEvent(eventDispatchers.SHOW_OVERLAY)
                this.showNextMoneyHuntingPresentation();;
            })

        })
    }

    /**
     * remove spotlight if on sticky frames
     * @param elementPos 
     * @param spotlightPos 
     */
    private removeSpotLightSymbol(elementPos: number[], spotlightPos: number[]) {
        if (elementPos[0] == spotlightPos[0] && elementPos[1] == spotlightPos[1]) {
            if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
                this.stickyFetaureContainer.getChildByName(`spotlight_${spotlightPos[0]}_${spotlightPos[1]}`).visible = false;
            } else {
                this.stickyFetaureContainerFG.getChildByName(`spotlight_${spotlightPos[0]}_${spotlightPos[1]}`).visible = false;

            }
        }
    }

    private checkIfChildExist(elementPos: number[]): any {
        let childExist: any;
        if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
            childExist = this.rewardSymbolContainer.getChildByName(`symbol_${elementPos[0]}${elementPos[1]}`);
            childExist = childExist?.children.length;
        } else {
            childExist = this.rewardSymbolContainerFG.getChildByName(`symbol_${elementPos[0]}${elementPos[1]}`);
            childExist = childExist?.children.length;
        }
        return childExist;
    }

    private addRewardSymbols(): void {
        let spotlightPos = (ingenuity.parserModel as GameParserModel).getSpotlightPosition();
        this.monayHuntingData = (ingenuity.parserModel as GameParserModel).getMoneyHuntingRewardsDetails();
        this.playSound(SoundConstantGame.COINS_APPEAR_SOUND, SlotConstantsBehavior.SOUND_LIST_POSTLOAD, false)
        this.monayHuntingData.forEach((element: any, index: number) => {
            let symbolSpine;
            let childExist = null;
            let childMtrValue: Meter | MeterBitmap;
            this.removeSpotLightSymbol(element.position, spotlightPos)
            childExist = this.checkIfChildExist(element.position);
            if (!childExist) {
                let rewardContainer = clone(ingenuity.assetsData.getJSONById("main_data").moneyHunting['stickyFrameReward']);
                let rewardContainerChild = this.view.createContainer(rewardContainer);
                symbolSpine = this.getSpineJson(element);
                childMtrValue = this.getMeterJson(element.reward);
                symbolSpine.type = "spine";
                //create elements
                let childSpine = this.view.createSpineClone(symbolSpine);
                childSpine.visible = true;
                childMtrValue.scale.set(0, 0);
                childMtrValue.x = childMtrValue.x + 0.1;
                if (element.reward == 'multiplier') {
                    childMtrValue.setText(element.multiplier + 'x');
                } else {
                    childMtrValue.setCurrencyFormattedValue((element.prize * ingenuity.parserModel.getCurrentTotalBet()).toString());
                }
                rewardContainerChild.name = `symbol_${element.position[0]}${element.position[1]}`;
                (rewardContainerChild as any).id = `symbol_${element.position[0]}${element.position[1]}`;

                rewardContainerChild.x = this.view.json.xPos[element.position[0]];
                rewardContainerChild.y = this.view.json.yPos[element.position[1]];
                if (element.reward == 'multiplier') {
                    rewardContainerChild.x = this.view.json.xPos[element.position[0]] + gameConstants.SHIFT_MULTIPLIER_SYM;
                }
                // rewardContainerChild.x = childSpine.x + this.view.json.symWidth * element.position[0] + (element.position[0] * 2);
                // rewardContainerChild.y = childSpine.y + this.view.json.rewardSymbolHeight * element.position[1];
                rewardContainerChild.visible = true;
                rewardContainerChild.addChild(childSpine);
                rewardContainerChild.addChild(childMtrValue);
                this.addChildToRewardContainer(rewardContainerChild);
                this.playSymbolAnimation(childSpine, element.prize, element.reward);
                this.removeSymbolOnReel(element.position);
                if (element.reward == 'multiplier') {
                    this.showMtrValueMultiplierWithTween(childMtrValue);
                }
                if (element.reward !== 'collect') {
                    this.showMtrValue(childMtrValue);
                }
            }
            if (index == this.monayHuntingData.length - 1) {
                this.showNextMoneyHuntingPresentation();
            }
        });
    }

    /**
     * hide symbol on reel
     * @param position offset on reel
     */
    private removeSymbolOnReel(position: any) {
        if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
            dispatcher.fireEvent(eventDispatchers.HIDE_SYMBOL_ON_REEL, position);
        } else {
            dispatcher.fireEvent(eventDispatchers.HIDE_SYMBOL_ON_REEL_FG, position);
        }
    }

    private playSound(sound: string, key: string, loop: boolean) {
        const soundObj: IObject = { id: sound, vol: 1, loop: loop, key: key };
        dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, soundObj);
    }

    private getSpineJson(element: any): any {
        let spineJson;
        if (element.reward == 'prize') {
            spineJson = clone(ingenuity.assetsData.getJSONById("main_data").moneyHunting['value_symbol_animation']);
        }
        else if (element.reward == 'multiplier') {
            this.isMultiplierOnReel = true;
            this.multiplerData.push(element);
            spineJson = clone(ingenuity.assetsData.getJSONById("main_data").moneyHunting['special_multiply']);
        } else if (element.reward == 'collect') {
            this.collectSymbolData.push(element);
            spineJson = clone(ingenuity.assetsData.getJSONById("main_data").moneyHunting['symbol_collect']);
        }

        return spineJson;
    }

    private getMeterJson(reward: string): any {
        let meterJson;
        let meter: Meter | MeterBitmap;
        if (reward == 'multiplier') {
            meterJson = clone(ingenuity.assetsData.getJSONById("main_data").moneyHunting['winMtrValueMultipler']);
            meter = this.view.creteMeterBitmapClone(meterJson) as MeterBitmap;
            meter.pivot.set(70, 30)
        }
        else {
            meterJson = clone(ingenuity.assetsData.getJSONById("main_data").moneyHunting['winMtrValue']);
            meter = this.view.creteMeterClone(meterJson) as Meter;
            meter.pivot.set(50, 50)
        }
        return meter;
    }

    private addChildToRewardContainer(rewardContainerChild: Container): void {
        if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
            this.rewardSymbolContainer.addChild(rewardContainerChild);
            this.rewardSymbolContainer.visible = true;

        } else {
            this.rewardSymbolContainerFG.addChild(rewardContainerChild)
            this.rewardSymbolContainerFG.visible = true;
        }

    }

    private playSymbolAnimation(child: SpineBase, prize: number, reward: string): void {
        if (reward == 'prize') {
            const fixed: any = Number(prize.toFixed(6)); // limit floating noise
            prize = Number.isInteger(fixed) ? fixed : fixed;
            child.playAnim('ll_symbols_out_glow');
            child.onComplete.addOnce(() => {
                if (prize == 0.2) {
                    child.playAnim('ll_1_in');
                } else if (prize == 0.5) {
                    child.playAnim('ll_2_in');
                } else {
                    child.playAnim('ll_3_in');
                }
            })
        } else if (reward == 'multiplier') {
            child.playAnim('special_multiply_in');
            child.onComplete.addOnce(() => {
                child.playAnim('special_multiply_static_tab');
            })
        } else if (reward == 'collect') {
            child.playAnim('symbol_collect_in', false);
        }
    }
    private onApplyMultiplier(): void {
        delayedCall('applyMultiplier', SlotConstantsBehavior.DURATION_2000, () => {
            killDelayedCall('applyMultiplier');
            if (this.isMultiplierOnReel) {
                this.playSound(SoundConstantGame.MULTIPLIER_WIN, SlotConstantsBehavior.SOUND_LIST_POSTLOAD, false)
                this.applyMultiplier();
            } else {
                this.showNextMoneyHuntingPresentation();
            }
        })
    }
    private applyMultiplier(): void {
        this.multiplerData.forEach((element: any) => {
            let container: Container;
            if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
                container = this.rewardSymbolContainer.getChildByName(`symbol_${element.position[0]}${element.position[1]}`) as Container;
            } else {
                container = this.rewardSymbolContainerFG.getChildByName(`symbol_${element.position[0]}${element.position[1]}`) as Container;
            }
            container.parent.addChild(container)
            element.adjacentTiles.forEach((tiles: any, index: number) => {
                this.zoomInOutMultiplierValue(container);
                let smokeEffect = clone(ingenuity.assetsData.getJSONById("main_data").moneyHunting['special_multiply']);
                let arrow = clone(ingenuity.assetsData.getJSONById("main_data").moneyHunting['special_multiply']);
                let smokeEffectSpine = this.view.createSpineClone(smokeEffect);
                let arrowSpine = this.view.createSpineClone(arrow);
                smokeEffectSpine.state.timeScale = 3; // Double speed (faster)
                arrowSpine.visible = smokeEffectSpine.visible = true;
                smokeEffectSpine.name = `smoke_effect${index}`;
                arrowSpine.name = `arrow_effect${index}`;
                let diff = (element.offSet - tiles.offSet).toString()
                arrowSpine.angle = smokeEffectSpine.angle = this.smokeEffectAngle[diff];
                container.addChild(arrowSpine)
                container.addChild(smokeEffectSpine);
                arrowSpine.playAnim('arrow');
                smokeEffectSpine.playAnim('smoke_effect');
                (ingenuity.soundManager as any).playSound(SoundConstantGame.PLATE_WIN, 1, false, SlotConstantsBehavior.SOUND_LIST_POSTLOAD);

                tiles.prize = tiles.prize * element.multiplier;
                delayedCall(`updatePrize${tiles.offSet}`, gameConstants.TIMER_100, () => {
                    killDelayedCall(`updatePrize${tiles.offSet}`)
                    this.updatePrizeValue(tiles)
                })
            });
        });
        delayedCall('applyCollect', SlotConstantsBehavior.DURATION_1000, () => {
            killDelayedCall('applyCollect');
            this.showNextMoneyHuntingPresentation();
        })
    }

    private onWinCollectionStart() {
        this.checkForTrailAvailable();
        if (this.isTrailAvailable) {
            // delayedCall('startWinCollection', SlotConstantsBehavior.DURATION_2000, () => {
            //     killDelayedCall('startWinCollection');
            this.startCollectionTrail();
            if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
                this.onStageClick();
            } else {
                this.onStageClickFg();
            }
            // })
        } else {
            this.startCollectionTrail();
            this.showNextMoneyHuntingPresentation();
        }
    }
    private checkForTrailAvailable(): void {

        this.monayHuntingData?.forEach((data: any) => {
            if (data.reward === "prize") {
                this.isTrailAvailable = true;
            }
        })
    }

    /**
  * add stage click to intro container
  */
    private onStageClick(): void {
        this.introPopupBG.interactive = true;
        this.introPopupBG.inputEnabled = true;
        this.introPopupBG &&
            this.introPopupBG.events.onInputUp.add((e: any) => {
                this.skipWinCollection();
                this.offStageClick();
            }, this);
    }
    private onStageClickFg(): void {
        this.introPopupFG.interactive = true;
        this.introPopupFG.inputEnabled = true;
        this.introPopupFG &&
            this.introPopupFG.events.onInputUp.add((e: any) => {
                this.skipWinCollection();
                this.offStageClickFg();
            }, this);
    }

    private skipWinCollection(): void {
        ingenuity.configData.moneyHuntingSkipPressed = true;
        if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
            this.showAllEmptyCoins(this.rewardSymbolContainer);
            dispatcher.fireEvent(eventDispatchers.STOP_WIN_TICK_UP);
            dispatcher.fireEvent(EventConstants.UPDATE_BS_WIN, {
                value: (ingenuity.parserModel as GameParserModel).getMoneyHuntingTotalWin() + (ingenuity.parserModel as GameParserModel).getTotalCascadeWin(),
            });
            delayedCall('updateTotalWin', SlotConstantsBehavior.DURATION_1000, () => {
                killDelayedCall('updateTotalWin');
                (ingenuity.parserModel as GameParserModel).setTotalCascadeWin((ingenuity.parserModel as GameParserModel).getTotalCascadeWin() + (ingenuity.parserModel as GameParserModel).getMoneyHuntingTotalWin());
                this.showNextMoneyHuntingPresentation();
            })
        } else {
            this.showAllEmptyCoins(this.rewardSymbolContainerFG);
            dispatcher.fireEvent(eventDispatchers.STOP_WIN_TICK_UP_FG);
            (ingenuity.parserModel as GameParserModel).setTotalFgCascadeWin((ingenuity.parserModel as GameParserModel).getTotalFgCascadeWin() + (ingenuity.parserModel as GameParserModel).getMoneyHuntingTotalWin());
            dispatcher.fireEvent(SlotEventConstantsBehavior.CONSOLE_TOTAL_WIN_METER, (
                (ingenuity.parserModel as GameParserModel).getCurrentlyProcessingFSAmt() +
                (ingenuity.parserModel as GameParserModel).getTotalFgCascadeWin()
            ));
            delayedCall('updateTotalWin', SlotConstantsBehavior.DURATION_1000, () => {
                killDelayedCall('updateTotalWin');
                this.showNextMoneyHuntingPresentation();
            })
        }
    }

    /**
     * remove stage click sfter click from intro container
     */
    private offStageClick(): void {
        this.introPopupBG.interactive = false;
        this.introPopupBG.inputEnabled = false;
        this.introPopupBG && this.introPopupBG.events.onInputUp.dispose();
    }
    private offStageClickFg(): void {
        this.introPopupFG.interactive = false;
        this.introPopupFG.inputEnabled = false;
        this.introPopupFG && this.introPopupFG.events.onInputUp.dispose();
    }

    private getElementContainer(): Container {
        let element;
        if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
            element = this.rewardSymbolContainer.getChildByName(`symbol_${this.monayHuntingData[this.winCollectionIndex].position[0]}${this.monayHuntingData[this.winCollectionIndex].position[1]}`) as Container;
        } else {
            element = this.rewardSymbolContainerFG.getChildByName(`symbol_${this.monayHuntingData[this.winCollectionIndex].position[0]}${this.monayHuntingData[this.winCollectionIndex].position[1]}`) as Container;
        }
        return element;
    }

    private showAllEmptyCoins(container: Container) {
        container.children.forEach((child: any) => {
            let symbolId: number;
            let rewardSymbol = child.children[0];
            let meterValue = child.children[1];
            let offset = child.name.split("_")[1].split("")
            if (rewardSymbol.name == "special_multiply") {
                symbolId = 29;
            } else if (rewardSymbol.name == 'symbol_collect') {
                rewardSymbol.playAnim('symbol_collect_full_to_empty');
                symbolId = 28;
            } else {
                if (meterValue.getValue() < 0.5) {
                    symbolId = 25;
                    rewardSymbol.playAnim('ll_1_frame_out')
                } else if (meterValue.getValue() >= 0.5 && meterValue.getValue() < 1) {
                    symbolId = 26;
                    rewardSymbol.playAnim('ll_2_frame_out')
                } else if (meterValue.getValue() >= 1) {
                    symbolId = 27;
                    rewardSymbol.playAnim('ll_3_frame_out2')
                }
            }
            meterValue.visible = false;
            this.updateReelSymbols(offset, symbolId);
        });

    }

    private startCollectionTrail(): void {
        if (this.winCollectionIndex < this.monayHuntingData.length) {
            let element: Container;
            let symbolId: number;
            element = this.getElementContainer();
            let rewardSymbol = element.children[0];
            let meterValue = element.children[1];
            ++this.winCollectionIndex;
            let offset = element.name.split("_")[1].split("")
            let data = { col: offset[0], row: offset[1], index: this.winCollectionIndex };
            if (rewardSymbol.name !== "special_multiply" && this.isTrailAvailable) {
                dispatcher.fireEvent(eventDispatchers.PLAY_WIN_COLLECTION_COIN_TRAIL, data);
                this.playSound(SoundConstantGame.COIN_COLLECTOR_WIN, SlotConstantsBehavior.SOUND_LIST_POSTLOAD, false)
                if (rewardSymbol.name == 'symbol_collect') {
                    rewardSymbol.playAnim('symbol_collect_full_to_empty');
                    symbolId = 28;
                } else {
                    if (meterValue.getValue() < 0.5) {
                        symbolId = 25;
                        rewardSymbol.playAnim('ll_1_frame_out')
                    } else if (meterValue.getValue() >= 0.5 && meterValue.getValue() < 1) {
                        symbolId = 26;
                        rewardSymbol.playAnim('ll_2_frame_out')
                    } else if (meterValue.getValue() >= 1) {
                        symbolId = 27;
                        rewardSymbol.playAnim('ll_3_frame_out2')
                    }
                }
                meterValue.visible = false;
                this.updateFeatureWin(meterValue.getValue())
            } else {
                if (rewardSymbol.name === "special_multiply") {
                    symbolId = 29;
                } else if (rewardSymbol.name === 'symbol_collect') {
                    symbolId = 28;
                }
                this.startCollectionTrail();
            }
            this.updateReelSymbols(offset, symbolId);
        } else {
            if (this.isTrailAvailable) {
                delayedCall('updateTotalWin', SlotConstantsBehavior.DURATION_1000, () => {
                    killDelayedCall('updateTotalWin');
                    this.offStageClickFg();
                    this.offStageClick();
                    (ingenuity.parserModel as GameParserModel).setTotalCascadeWin((ingenuity.parserModel as GameParserModel).getTotalCascadeWin() + (ingenuity.parserModel as GameParserModel).getMoneyHuntingTotalWin());
                    this.showNextMoneyHuntingPresentation();
                })
            } else {
                this.showNextMoneyHuntingPresentation();
            }

        }
    }

    private updateReelSymbols(offset: string[], symbolId: number) {
        if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
            dispatcher.fireEvent(eventDispatchers.UPDATE_MONEY_HUNTING_SYMBOL_ON_REEL, { offset: offset, symbolId: symbolId })
        } else {
            dispatcher.fireEvent(eventDispatchers.UPDATE_MONEY_HUNTING_SYMBOL_ON_REEL_FG, { offset: offset, symbolId: symbolId })
        }
    }

    /**
    * method to update the hold and re spin feature win
    * @param multiplier
    */
    private updateFeatureWin(multiplier: number): void {
        if (multiplier) {
            let value;
            if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
                value = (ingenuity.parserModel as GameParserModel).getCascadeAccumulatedWin() + multiplier;
                (ingenuity.parserModel as GameParserModel).setCascadeAccumulatedWin(value);
                dispatcher.fireEvent(EventConstants.UPDATE_BS_WIN, {
                    value: value,
                });
                dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_BASE_GAME_WIN_METER);
            } else {
                // value = ((ingenuity.parserModel as GameParserModel).getCurrentlyProcessingFSAmt()) + multiplier;
                // (ingenuity.parserModel as GameParserModel).setFreeSpinWinAmt(value);

                value = (ingenuity.parserModel as GameParserModel).getCascadeAccumulatedWin() + multiplier;
                (ingenuity.parserModel as GameParserModel).setCascadeAccumulatedWin(value);

                dispatcher.fireEvent(SlotEventConstantsBehavior.CONSOLE_TOTAL_WIN_METER, ((ingenuity.parserModel as GameParserModel).getCurrentlyProcessingFSAmt() + value))

                // dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_TOTAL_WIN_MSG);
            }
        }
    }


    /**
     * multiplier value on symbol zoom in out when multipler is applied
     * @param container 
     */
    private zoomInOutMultiplierValue(container: Container): void {
        let mtrValue = container.getChildAt(1) as Meter;
        mtrValue.pivot.set(70, 30)
        let childMtrValueTween = ingenuity.currentGame.add.tween(mtrValue.scale).to({ x: 0.5, y: 0.5 }, gameConstants.TIMER_200, Linear.None, true, 100, 0, false);
        childMtrValueTween.onComplete.addOnce(() => {
            childMtrValueTween.stop();
            ingenuity.currentGame.tweens.remove(childMtrValueTween);
            let childMtrValueTween1 = ingenuity.currentGame.add.tween(mtrValue.scale).to({ x: 2, y: 2 }, gameConstants.TIMER_200, Linear.None, true, 100, 0, false);
            childMtrValueTween1.onComplete.addOnce(() => {
                childMtrValueTween1.stop();
                ingenuity.currentGame.tweens.remove(childMtrValueTween1);
                let childMtrValueTween2 = ingenuity.currentGame.add.tween(mtrValue.scale).to({ x: 0, y: 0 }, gameConstants.TIMER_200, Linear.None, true, 100, 0, false);
                childMtrValueTween2.onComplete.addOnce(() => {
                    ingenuity.currentGame.tweens.remove(childMtrValueTween2);
                    childMtrValueTween2.stop();
                })
            })
        });
    }

    private updatePrizeValue(tiles: any): void {
        if (tiles.reward == 'prize') {
            let tilesContainer: Container;
            if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
                tilesContainer = this.rewardSymbolContainer.getChildByName(`symbol_${tiles.position[0]}${tiles.position[1]}`) as Container;
            } else {
                tilesContainer = this.rewardSymbolContainerFG.getChildByName(`symbol_${tiles.position[0]}${tiles.position[1]}`) as Container;
            }
            let symbolSpine: SpineBase = tilesContainer.getChildAt(0) as SpineBase;
            if (tiles.prize < 0.2) {
                symbolSpine.playAnim('ll_1_smoke_hit_effect');
            } else if (tiles.prize > 0.2 && tiles.prize < 0.5) {
                symbolSpine.playAnim('ll_2_smoke_hit_effect');
            } else if (tiles.prize > 0.5) {
                symbolSpine.playAnim('ll_3_smoke_hit_effect');
            }
            let mtrValue = tilesContainer.getChildAt(1) as Meter;
            mtrValue.startTick(tiles.prize * ingenuity.parserModel.getCurrentTotalBet(), true, false, 0.5, true, null, this)
            this.isMultiplierOnReel = false;
        }
    }

    private showMtrValue(childMtrValue: Meter | MeterBitmap): void {
        childMtrValue.visible = true;
        let childMtrValueTween = ingenuity.currentGame.add.tween(childMtrValue.scale).to({ x: 1, y: 1 }, 50, Linear.None, true, gameConstants.TIMER_100, 0, false);
        childMtrValueTween.onComplete.addOnce(() => {
            childMtrValueTween.stop();
            ingenuity.currentGame.tweens.remove(childMtrValueTween);
        });
    }

    private showMtrValueMultiplierWithTween(childMtrValue: Meter | MeterBitmap): void {
        let childMtrValueTween = ingenuity.currentGame.add.tween(childMtrValue).to({ y: 41 }, gameConstants.TIMER_100, Linear.None, true, gameConstants.TIMER_100, 0, false);
        childMtrValueTween.onComplete.addOnce(() => {
            childMtrValueTween.stop();
            ingenuity.currentGame.tweens.remove(childMtrValueTween);
        });
    }

    private onApplyCollect(): void {
        if ((ingenuity.parserModel as GameParserModel).getCollectPosition().length > 0 && (ingenuity.parserModel as GameParserModel).getPrizeCoinPositions().length > 0) {
            this.playSound(SoundConstantGame.COLLECTOR_WIN, SlotConstantsBehavior.SOUND_LIST_POSTLOAD, false);
            const collectPos = (ingenuity.parserModel as GameParserModel).getCollectPosition()[0];
            (ingenuity.parserModel as GameParserModel).getPrizeCoinPositions().forEach((offset: number[], index: number) => {
                if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
                    this.hideRewardSymbol(this.rewardSymbolContainer.getChildByName(`symbol_${offset[0]}${offset[1]}`) as Container);
                } else {
                    this.hideRewardSymbol(this.rewardSymbolContainerFG.getChildByName(`symbol_${offset[0]}${offset[1]}`) as Container);
                }
                delayedCall(`collectRewards${index}`, SlotConstantsBehavior.DURATION_200, () => {
                    killDelayedCall(`collectRewards${index}`);
                    this.collectAllRewardInBag(offset, collectPos, index)
                })
            })
        } else {
            this.showNextMoneyHuntingPresentation();
        }
    }
    private hideRewardSymbol(container: Container): void {
        let symbolSpine: SpineBase = container.children[0];
        let symbolMeter: MeterBehavior = container.children[1];
        this.collectPrize = this.collectPrize + symbolMeter.getValue();
        let containerTween = ingenuity.currentGame.add.tween(container.scale).to({ x: 1.1, y: 1.1 }, 50, Linear.None, true, gameConstants.TIMER_100, 0, false);
        containerTween.onComplete.addOnce(() => {
            this.playOutAnimation(symbolSpine, symbolMeter);
            let containerTween = ingenuity.currentGame.add.tween(container.scale).to({ x: 0, y: 0 }, 50, Linear.None, true, gameConstants.TIMER_200, 0, false);
            containerTween.onComplete.addOnce(() => {
                container.scale.set(1)
                container.removeChildren()
                container.children = []
                containerTween.stop();
                ingenuity.currentGame.tweens.remove(containerTween);
                if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
                    this.rewardSymbolContainer.removeChild(container)
                } else {
                    this.rewardSymbolContainerFG.removeChild(container)
                }
            });
        });
    }

    private playOutAnimation(spine: SpineBase, meter: Meter) {
        if (spine.name == "special_multiply") {
            spine.playAnim('special_multiply_out')
        } else if (spine.name == "symbol_collect") {
            spine.playAnim('symbol_collect_empty_to_full_glow');
        } else {
            let value = meter.getValue();
            spine.playAnim('ll_symbols_out_glow');
            spine.onComplete.addOnce(() => {
                if (value < 0.2) {
                    spine.playAnim('ll_1_out');
                } else if (value > 0.2 && value < 0.5) {
                    spine.playAnim('ll_2_out');
                } else if (value > 0.5) {
                    spine.playAnim('ll_3_out');
                }
            })
        }

    }
    private collectAllRewardInBag(initial: number[], final: number[], index: number): void {
        const movingContainer = this.createMovingCont(initial);
        this.initializeCoinShowerEmitter(movingContainer, initial)
        this.playTrailAnimation(final, movingContainer, index, initial);
    }



    /**
     * to create spine symbol
     * */
    private createMovingCont(initialPos: number[]): Container {
        const containerJSON: any = clone(this.view.json["cloneContainer"]);
        containerJSON.type = "container";
        const container: Container = this.view.createContainer(containerJSON);
        container.visible = true;
        container.name = "cloneContainer_" + initialPos[0] + initialPos[1]
        container.x = initialPos[0] * this.view.json.symWidth;
        container.y = initialPos[1] * this.view.json.symHeight;
        this.view.getContainerByID("movingContainer").addChild(container);
        return container;
    }
    /**
       * Initialize Data for Emmiter
       */
    private initializeCoinShowerEmitter(cloneContainer: Container, initalPos: number[]): void {
        const particleData: any = {
            emitterType: 0,
            id: "winCoinEmitter",
            autoStart: false,
            image: [
                "orange",
                "blue_trail"// change it with coin
            ],
        };
        const config = {
            alpha: {
                start: 1,
                end: 0,
            },
            scale: {
                start: 3,
                end: 1,
                minimumScaleMultiplier: 1,
            },
            color: {
                start: "#ffffff",
                end: "#ffffff",
            },
            speed: {
                start: 0,
                end: 0,
                minimumSpeedMultiplier: 1,
            },
            acceleration: {
                x: 0,
                y: 0,
            },
            maxSpeed: 0,
            lifetime: {
                min: 0.2,
                max: 1,
            },
            blendMode: "screen",
            frequency: 0.001,
            emitterLifetime: -1,
            maxParticles: 300,
            pos: {
                x: 0,
                y: 0,
            },
            addAtBack: false,
            spawnType: "point"
        }
        particleData.id = cloneContainer.name;
        const bubbleTrail = ingenuity.currentGame.add.emitter(this.view.getContainerByID("collectTrailCont"), particleData, config) as Emitter;
        bubbleTrail.autoUpdate = true;
        bubbleTrail.emit = true;
        const initialXPos = initalPos[0] * this.view.json.symWidth
        const initialYPos = initalPos[1] * this.view.json.symHeight
        bubbleTrail.updateOwnerPos(initialXPos, initialYPos);
    }

    /**
     * Play tween to move symbol and will update emitter origin point to make it trail
     */
    private playTrailAnimation(finalPos: number[], movingCont: Container, index: number, initialPos: number[]): void {
        let curveVal = 0.7;
        const finalXPos = finalPos[0] * this.view.json.symWidth
        const finalYPos = finalPos[1] * this.view.json.symHeight;
        const initialXPos = initialPos[0] * this.view.json.symWidth
        const initialYPos = initialPos[1] * this.view.json.symHeight

        let position = this.bezierCurve(initialXPos, initialYPos, finalXPos, finalYPos, curveVal);

        let trailTween: ITween;
        trailTween = ingenuity.currentGame.add.tween(movingCont);
        trailTween.to({ x: position[0], y: position[1] }, 500, undefined, true);
        trailTween.onUpdateCallback((evt: IObject) => {
            let em: Emitter;
            em = ingenuity.currentGame.particles.getEmitterById(evt.target.name);
            em.updateOwnerPos(evt.target.x, evt.target.y);
        });
        trailTween.onComplete.addOnce(() => {
            let em: Emitter;
            em = ingenuity.currentGame.particles.getEmitterById(trailTween.target.name);
            em.autoUpdate = false;
            em.emit = false;
            em.destroy();
            ingenuity.currentGame.tweens.remove(trailTween);
            trailTween.target.parent.removeChild(trailTween.target);
            if (index === (ingenuity.parserModel as GameParserModel).getPrizeCoinPositions().length - 1) {
                this.playBagFullAnimation(finalPos);
                this.removeContainers();
            }
        }, this);
    }
    //create a curve path array position
    private bezierCurve(startX: number, startY: number, endX: number, endY: number, curveFactor: number): number[][] {
        // startX: X-coordinate of the starting point of the line
        // startY: Y-coordinate of the starting point of the line
        // endX: X-coordinate of the ending point of the line
        // endY: Y-coordinate of the ending point of the line
        // curveFactor: Factor determining the amount of curvature in the curve

        // Calculate control point coordinates
        const controlX = (startX + endX) / 2 - Math.abs(startX - endX) * curveFactor; // X-coordinate of the control point (midpoint)
        const controlY = (startY + endY) / 2; // Y-coordinate of the control point

        // Arrays to store X and Y coordinates of points along the curve
        let curveX: number[] = []; // Array to store X coordinates
        let curveY: number[] = []; // Array to store Y coordinates

        // Number of points to calculate along the curve
        const numberOfPoints = 50; // You can adjust this value based on the desired smoothness of the curve

        // Loop to calculate coordinates of points along the curve
        for (let i = 0; i <= numberOfPoints; i++) {
            const t = i / numberOfPoints; // Parameterization along the Bézier curve (ranges from 0 to 1)
            const x = Math.pow(1 - t, 2) * startX + 2 * (1 - t) * t * controlX + Math.pow(t, 2) * endX; // X-coordinate of the point on the curve
            const y = Math.pow(1 - t, 2) * startY + 2 * (1 - t) * t * controlY + Math.pow(t, 2) * endY; // Y-coordinate of the point on the curve
            curveX.push(x); // Add X-coordinate to the array
            curveY.push(y); // Add Y-coordinate to the array
        }

        // Return arrays of X and Y coordinates of points along the curve
        return [curveX, curveY];
    }

    private playBagFullAnimation(finalPos: number[]): void {
        let collectSymbol: Container;
        if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
            collectSymbol = this.rewardSymbolContainer.getChildByName(`symbol_${finalPos[0]}${finalPos[1]}`) as Container;
        } else {
            collectSymbol = this.rewardSymbolContainerFG.getChildByName(`symbol_${finalPos[0]}${finalPos[1]}`) as Container;
        }
        collectSymbol.children[0].playAnim('symbol_collect_empty_to_full');
        delayedCall('collectMtrValue', SlotConstantsBehavior.DURATION_200, () => {
            killDelayedCall('collectMtrValue');
            collectSymbol.children[1].y = 62;
            collectSymbol.children[1].setCurrencyFormattedValue(this.collectPrize);
            this.showMtrValue(collectSymbol.children[1]);
        })
        collectSymbol.children[0].onComplete.addOnce(() => {
            collectSymbol.children[0].playAnim('symbol_collect_full_static_tab');
            this.onCollectPresentationComplete();
        })
    }

    private onCollectPresentationComplete(): void {
        this.collectPrize = 0;
        (ingenuity.parserModel as GameParserModel).setPrizeCoinPositions(null);
        (ingenuity.parserModel as GameParserModel).setCollectPosition(null);
        (ingenuity.parserModel as GameParserModel).setMoneyRewardSpinsCounter((ingenuity.parserModel as GameParserModel).getMoneyRewardSpinsCounter() + 1);
        this.multiplerData = [];
        this.collectSymbolData = [];
        (ingenuity.parserModel as GameParserModel).setMoneyHuntingRewardsDetails([]);
        dispatcher.fireEvent(eventDispatchers.PARSE_NEXT_MONEY_HUNT_DATA);
        this.moneyHuntingCounter = this.moneyHuntingArray.indexOf("addRewardSymbol");
        delayedCall('showNextCallSymbols', SlotConstantsBehavior.DURATION_500, () => {
            killDelayedCall('showNextCallSymbols')
            this.showNextMoneyHuntingPresentation();
        })
    }

    private removeContainers(): void {
        this.view.getContainerByID("movingContainer").removeChildren();
        this.view.getContainerByID("movingContainer").children = [];
        this.view.getContainerByID("collectTrailCont").removeChildren();
        this.view.getContainerByID("collectTrailCont").children = [];
    }

}